module.exports = __webpack_public_path__ + "img/ic_share.8b449023.svg";